import React from 'react';

export default function BulletTankReport() {
  return <div>BulletTankReport</div>;
}
